// export const insLogin = createAssign<TInsLoginData>({
import type { TBlueObj } from "@app/types/insider";
import type { TInsLoginData } from "@app/types";
//this is a Insider/JGAP storeObject.
export const jgLogin: TBlueObj<TInsLoginData> = {
  name: "jgLogin",
  initialState: {
    AMAXAVOID: -1,
    INSIDER: "",
    DISPLAY_NAME: "",
    DREPT_SUPREM: 0,
    DREPT_FACTURARE: 0,
    LOGINCTX: "",
  },
  starfx: false,
  idb: false,
};
